import type { ExecutionFeedOperation } from "./tracking/feed-operation";
import type {
  ExecutionHandle,
  ToastId,
  TrackExecutionOptions,
} from "./types";

export interface ToastExecutionBindings {
  dismissExecution: (operationId: string) => void;
  openExecution: (operationId: string) => void;
  publishFeedOperations: (
    operations: readonly ExecutionFeedOperation[],
  ) => void;
  trackExecution: (
    handle: ExecutionHandle,
    options?: TrackExecutionOptions,
  ) => ToastId;
}

let executionBindings: ToastExecutionBindings | null = null;

export function getToastExecutionBindings(): ToastExecutionBindings | null {
  return executionBindings;
}

export function registerToastExecutionBindings(
  bindings: ToastExecutionBindings,
): void {
  executionBindings = bindings;
}

export function resetToastExecutionBindings(): void {
  executionBindings = null;
}
